(function() {
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    document.querySelectorAll('[data-hja-countdown]').forEach(function(el) {
      var target = Date.parse(el.dataset.target);
      var diff = Math.max(0, target - Date.now());
      var vals = {
        days: pad(Math.floor(diff / 86400000)),
        hours: pad(Math.floor(diff / 3600000) % 24),
        mins: pad(Math.floor(diff / 60000) % 60),
        secs: pad(Math.floor(diff / 1000) % 60)
      };
      el.querySelectorAll('[data-cd]').forEach(function(span) {
        span.textContent = vals[span.dataset.cd];
      });
    });
  }
  tick();
  setInterval(tick, 1000);
})();